import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spinner,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import React from "react";

const Welcome = () => {
  const { isOpen, onOpen } = useDisclosure();
  const AuthorizeRedirect =
    process.env.NODE_ENV !== "production"
      ? `https://radianse-app-gateway-dev.azurewebsites.net/users/api/authorize?r=${window.location.origin}`
      : `${window["_env"].APP_GATEWAY_URL}/users/api/authorize?r=${window.location.origin}`;

  React.useEffect(() => {
    setTimeout(() => {
      onOpen();
    }, 1500);
  }, [onOpen]);

  function onAuthorize() {
    window.location.href = AuthorizeRedirect;
  }
  return (
    <Flex alignContent={"center"} flex={1} justifyContent={"center"}>
      <Spinner
        size="xl"
        color="brand.secondary.500"
        thickness="3px"
        speed="0.65s"
        alignSelf={"center"}
      />
      <Modal isOpen={isOpen} isCentered size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader textAlign="center">
            <Text fontSize="2xl" color={"brand.primary.500"}>
              Welcome
            </Text>
          </ModalHeader>
          <ModalBody>
            <Text fontSize="md" color={"gray.500"} textAlign={"center"}>
              Click the button below to log in and authorize this device
            </Text>
          </ModalBody>
          <ModalFooter alignContent="center" justifyContent="center">
            <Button
              variant={"kioskPrimary"}
              onClick={onAuthorize}
              data-testid={"authorize-link"}
            >
              Authorize
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Flex>
  );
};

export default Welcome;
